import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RESOLUTIONS } from 'services/config';
import Highcharts from 'highcharts/highstock';
import highcharts3d from 'highcharts/highcharts-3d';
const CDN_URL = process.env.REACT_APP_CDN_URL;
const LeftArrow = `${CDN_URL}common/down-arrow-hover.svg`;
highcharts3d(Highcharts);

class LineGraph extends Component {
	constructor(props) {
		super(props);
		this.state = {
			error: null,
			page: 1,
		};
	}

	getGraphSize() {
		const { breakpoint, size } = this.props;

		let width = 245;
		let height = 300;
		let scrollBarHeight = 25;
		if (size === 'large') {
			width = 360;
			height = 300;
			scrollBarHeight = 30;
		}

		if (breakpoint === RESOLUTIONS.MED) {
			width = 350;
			height = 300;
			if (size === 'large') {
				width = 540;
				height = 380;
				scrollBarHeight = 25;
			}
		} else if (breakpoint === RESOLUTIONS.HIGH) {
			width = 600;
			height = 350;
			scrollBarHeight = 30;
			if (size === 'large') {
				width = 900;
				height = 600;
				scrollBarHeight = 30;
			}
		}

		return { width, height, scrollBarHeight };
	}
	isOverCommitment() {
		const { series, commitment_amount } = this.props;

		let over = false;
		series.filter(location => {
			const points = location?.data;
			points.map(point => {
				if (point > commitment_amount) {
					over = true;
				}
			});
		});

		return over;
	}

	sortSeries = series => {
		let newArray = series
			.sort(function (a, b) {
				const dataA = a.data;
				const dataB = b.data;

				return Math.max(...dataA) - Math.max(...dataB);
			})
			.reverse();

		newArray = newArray.filter(array => array?.data && array?.data.length !== 0);

		return newArray;
	};

	createChart = () => {
		const { id, categories, title, onClick, series, loadMoreData, commitment_amount, size, unit } =
			this.props;

		const { width, height, scrollBarHeight } = this.getGraphSize();

		let yAxisMax = commitment_amount;
		if (this.isOverCommitment() || size !== 'large') {
			yAxisMax = null;
		}
		const seriesSorted = this.sortSeries(series);
		const catLength = categories && categories?.length;

		let maxPoints = 3;
		if (catLength <= 3) {
			maxPoints = catLength - 1;
		}
		Highcharts.chart(`line-graph-container ${id}`, {
			chart: {
				height,
				width,
				type: 'area',
				events: {
					redraw: e => {
						const scrolled = e.target.scrollbar.scrollbarLeft;
						const { page } = this.state;

						if (scrolled / page > 50) {
							this.setState({ page: page + 1 });
							loadMoreData(page + 1);
						}
					},
				},
			},
			legend: {
				enabled: true,
			},
			title: {
				text: title,
			},
			credits: {
				enabled: false,
			},
			subtitle: {
				text: '',
			},
			xAxis: {
				tickmarkPlacement: 'on',
				min: 0,
				max: maxPoints,
				categories,
			},

			yAxis: {
				max: yAxisMax,

				plotLines: [
					{
						value: commitment_amount,
						color: 'red',
						dashStyle: 'shortdash',
						width: 2,
						label: '',
					},
				],
			},

			scrollbar: {
				enabled: true,
				trackBackgroundColor: 'white',
				trackBorderColor: 'white',
				barBorderWidth: 0,
				barBackgroundColor: 'white',
				barBorderColor: 'white',
				rifleColor: 'white',
				buttonBorderRadius: '14',
				buttonBackgroundColor: 'white',
				buttonBorderColor: 'white',
				height: scrollBarHeight,
				buttonArrowColor: 'white',
			},
			tooltip: {
				style: {
					textAlign: 'center',
				},
			},
			plotOptions: {
				area: {
					stacking: 'normal',
					lineColor: '#666666',
					lineWidth: 1,
					marker: {
						lineWidth: 1,
						lineColor: '#666666',
					},
				},
				series: {
					cursor: 'pointer',
					point: {
						events: {
							click(e) {
								onClick(e);
							},
						},
					},
					tooltip: {
						valueSuffix: unit,
						headerFormat: `<span style="opacity:0;">●HS</span><div style="text-align:center !important;">{point.x}</div> <br/>`,
						formatter:
							'<span style="color:{point.color}">●</span> {series.name}: <b>{point.y}</b><br/>',
						style: {
							textAlign: 'center',
						},
					},
				},
				line: {
					dataLabels: {
						enabled: false,
					},
					enableMouseTracking: true,
				},
			},
			series: seriesSorted,
		});
	};

	componentDidMount() {
		this.createChart();
	}
	componentDidUpdate(prevProps) {
		if (this.props !== prevProps) {
			this.createChart();
		}
	}

	render() {
		const { id } = this.props;

		return (
			<>
				<div id={`line-graph-container ${id}`} className={`line-graph-container ${id}`}></div>
				<img className='left-arrow' src={LeftArrow}></img>
				<img className='right-arrow' src={LeftArrow}></img>
			</>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth_status: state.auth_status,
	};
}

export default connect(mapStateToProps, null)(LineGraph);
